// WorkExperience.js
import React from 'react';

import '../styles/WorkExperience.css'

function WorkExperience() {
  const experiences = [
    {
      id: 1,
      companyName: 'Kotak Mahindra Bank Pvt Ltd',
      role: 'Deputy Manager',
      duration: '06/2022 - Present',
      location: 'Hyderabad',
      description: 'Working For Kotak Mahindra Bank Backend Development Using FICO BRE Tool.'
    },
    {
      id: 2,
      companyName: 'Abhyasana Technologies',
      role: 'Web Developer',
      duration: '09/2018 - 11/2019',
      location: 'Warangal, India',
      description: 'Involved in developing a website using PHP, HTML, CSS, and JavaScript.'
    },
    // Add additional experiences in the same format
  ];

  return (
    <div className="work-experience">
      <h2>Work Experience</h2>
      {experiences.map(exp => (
        <div key={exp.id} className="job">
          <h3>{exp.companyName}</h3>
          <p><strong>Role:</strong> {exp.role}</p>
          <p><strong>Duration:</strong> {exp.duration}</p>
          <p><strong>Location:</strong> {exp.location}</p>
          <p><strong>Description:</strong> {exp.description}</p>
        </div>
      ))}
    </div>
  );
}

export default WorkExperience;
